import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
@Component({
  selector: 'app-group-chat',
  templateUrl: './group-chat.component.html',
  styleUrls: ['./group-chat.component.scss']
})
export class GroupChatComponent implements OnInit {
  isCollapsed = true;
  projectTab: boolean = true;
  fileTab: boolean;
  groupTab: boolean;
  modalRef: BsModalRef;
  constructor(private modalService: BsModalService) { }

  ngOnInit(): void {
  }
  onMenuTab(number) {
    this.projectTab = false;
    this.fileTab = false;
    this.groupTab = false;
    if (number == '1') {
      this.projectTab = true;
    }
    else if (number == '2') {
      this.fileTab = true;
    }
    else if (number == '3') {
      this.groupTab = true;
    }

  }


  slidechat() {
    document.getElementById("show-user-detail").classList.toggle("open-chat-sidebar");
  }

  closechatside() {
    document.getElementById("show-user-detail").classList.remove("open-chat-sidebar");
  }

  slideuserchat() {
    document.getElementById("show-user-detail").classList.toggle("open-user-sidebar");
  }

  closeuserchatside() {
    document.getElementById("show-user-detail").classList.remove("open-user-sidebar");
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-lg' });
  }
}
